export const videoTestPublicUrl = 'https://h5-inside.vivo.com.cn/pcvivo/video6'
export const videoPrePublicUrl = 'https://h5-pre.vivo.com.cn/pcvivo/video6'
export const videoPrdPublicUrl = 'https://h5.vivo.com.cn/pcvivo/video6'
export const VIDEO_HOST = videoPrdPublicUrl

export default {
  a11y1: VIDEO_HOST + '/a11y1_compressed.webm',
  shake: VIDEO_HOST + '/crossEcology/shake_compressed.webm',
  fluidEngineBackground: VIDEO_HOST + '/fluidEngine/fluid-engine-background_compressed.webm', // 流畅引擎背景
  fluidEngineDualRenderingArchitecture: VIDEO_HOST + '/fluidEngine/dual-rendering-architecture_compressed.webm', // 双渲染架构
  fluidEnginePhotonicStorage: VIDEO_HOST + '/fluidEngine/photonic-storage_compressed.webm', // 光子存储
  fluidEngineHyperCoreComputing: VIDEO_HOST + '/fluidEngine/hyper-core-computing_compressed.webm', // 超核计算
  bouncyAnimationApp: VIDEO_HOST + '/fluidEngine/bouncy-animation-app_compressed.webm', // 弹性动画
  bouncyAnimationFocus: VIDEO_HOST + '/fluidEngine/bouncy-animation-focus_compressed.webm', // 弹性动画
  frameDeformationVideo: VIDEO_HOST + '/fluidEngine/frame-deformation_compressed.webm', // 帧变形
  frameBlurVideo: VIDEO_HOST + '/fluidEngine/frame-blur_compressed.webm', // 帧模糊
  naturalComfort: VIDEO_HOST + '/naturalComfort/naturalComfort_compressed.webm',
  lightSpace: VIDEO_HOST + '/newDesign/lightSpace_compressed.webm',
  ndaiLight: VIDEO_HOST + '/newDesign/ndaiLight_compressed.webm',
  oneShot: VIDEO_HOST + '/fluidEngine/one-shot_compressed.webm', // 一镜到底
  gratingWallpaperBlue: VIDEO_HOST + '/gratingWallpaper/gw-bg-blue_compressed.webm', // 光栅壁纸
  gratingWallpaperGrey: VIDEO_HOST + '/gratingWallpaper/gw-bg-grey_compressed.webm', // 光栅壁纸
  gratingWallpaperOrange: VIDEO_HOST + '/gratingWallpaper/gw-bg-orange_compressed.webm', // 光栅壁纸
  microPowerElf: VIDEO_HOST + '/performanceEndurance/micro-power-elf_compressed.webm', // 微电精灵
  livephoto: VIDEO_HOST + '/aiScreen/livephoto_compressed.webm',
  screenOff: VIDEO_HOST + '/firstScreen/screenOff_compressed.webm',
  eyeRight: VIDEO_HOST + '/eyeCare/eye-right_compressed.webm',
}
